var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconInbound = function SvgIconInbound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6185 64.8337L48.1763 71.7523L51.3132 75.1196L64.8453 62.5336L51.3132 49.9476L48.1763 53.3149L55.6185 60.2336H31.2956C25.9509 60.2336 21.5996 55.8818 21.5996 50.5364L21.6088 37.5732H17V50.5364C17 58.4211 23.4119 64.8337 31.2956 64.8337H55.6185Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4736 38.6313C93.4644 38.2265 93.354 37.8217 93.1148 37.4537C93.1056 37.4445 93.1056 37.4353 93.0964 37.4168V37.4076C93.0964 37.4076 93.0964 37.4076 93.0964 37.3984L84.1547 23.9936C83.7408 23.3772 83.0416 23 82.2965 23H41.7278C40.9827 23 40.2835 23.3772 39.8695 23.9936L30.9279 37.4076C30.9279 37.4076 30.9279 37.4168 30.9187 37.4168V37.4261C30.9095 37.4353 30.9095 37.4445 30.9003 37.4537C30.6795 37.7941 30.5507 38.1989 30.5415 38.6313C30.5415 38.6405 30.5415 38.6497 30.5415 38.6681V38.6773V38.6865V54.8882H35.0123V40.9038H53.0613H57.5321H66.483H70.9538H89.0027V82.4891H35.0215V69.6087H30.5507V87.0892H30.6795H35.0307H89.0211H93.2436H93.5012V38.6773V38.6681V38.6589C93.4828 38.6497 93.4736 38.6405 93.4736 38.6313ZM59.7215 36.4232H36.9626L42.9237 27.4713H59.7215V36.4232ZM64.1924 36.4232V27.4713H81.0914L87.0525 36.4232H64.1924Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInbound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-inbound.db89596c.svg";
export { ForwardRef as ReactComponent };